export default __webpack_public_path__ + "static/media/Crossword.7079fd831f1d39678c5448bd3c0ab333.webp";